// @ts-strict-ignore
import { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import strings from '../../../strings'
import { Helmet } from 'react-helmet'
import Page from '../../common/components/Page'
import { RootStoreState, AppManifest } from 'mytours-read-common'
import '../styles.less'
import BadgeGroupBlock from '../../badges/components/BadgeGroupBlock'
import { useSelector } from 'react-redux'
import AudioPlayerBarComponent from 'mobile_web/modules/audio/components/AudioPlayerBar'
import FavouriteGroupBlock from 'mobile_web/modules/favourites/components/FavouriteGroupBlock'
import PurchasedContentBlock from 'mobile_web/modules/purchasedcontent/components/PurchasedContentBlock'

const Profile: FC<RouteComponentProps> = () => {
	const appManifest = useSelector((state: RootStoreState) => state.settings.appManifest) as AppManifest
	const currentLanguage = useSelector((state: RootStoreState) => state.settings.selectedLanguage)
	const appMetaData = useSelector((state: RootStoreState) => state.settings.appMetaData)

	return (
		<>
			<Helmet
				title={strings.profile}
				meta={[
					{ name: 'description', content: strings.profile },
					{ property: 'og:type', content: 'website' },
					{ property: 'og:title', content: strings.profile },
					{ property: 'og:description', content: strings.profile },
					{ property: 'og:url', content: window.location.href },
				]}
			/>
			<Page
				contentProps={{
					className: 'profile-content',
				}}
				headerProps={{
					title: strings.profile,
					hideBackButton: true,
					hideShareButton: true,
					showSettingsButton: true,

					collectionItem: null,
					itemType: null,
					itemId: null,
					collection: null,
					screen: null,
					hideFavouriteButton: true,
				}}
				footer={{
					component: <AudioPlayerBarComponent bottomOffset={-1} />,
				}}
				dataCy="page-profile"
			>
				{/* Don't remove commented content - it will be used in future */}
				{/* <div className="block profile-block">
					<div className="block-header">
						<h2 className="subheading">{strings.badges}</h2>
						<Button fill="default" ariaLabel={strings.browse_all} href={getBadgesUrl()}>
							{strings.browse_all}
						</Button>
					</div>
					<div className={classNames('block-content', { '-with-content': badges && badges.length !== 0 })}>
						{badges && badges.length === 0 ? (
							<Text variant="inherit">{strings.profile_no_recently_earned_badges_text}</Text>
						) : (
							badges && badges?.map(item => <BadgeComponent key={item?.id} id={item?.id} />)
						)}
					</div>
				</div> */}
				{appMetaData?.badges_on_profile_enabled &&
					appManifest?.badge_groups
						?.sort((a, b) => a.position - b.position)
						?.map(group => <BadgeGroupBlock key={group?.id} group={group} currentLanguage={currentLanguage} />)}

				{appMetaData.favorites_enabled ? <FavouriteGroupBlock appManifest={appManifest} /> : null}

				<PurchasedContentBlock />
			</Page>
		</>
	)
}

export default Profile
